import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the React Messages remote flag is ENABLED.
 * Used for the remote-profile Messages overview and detail routes.
 * If this guard returns false, the legacy Angular Messages routes (without this guard) are the
 * fallback at the same paths.
 *
 * canMatch, not canActivate: LaunchDarklyUserGuard.canActivate redirects the browser when a flag
 * is off rather than resolving false, and canActivate does not fall through to the next route entry
 * at the same path regardless. Only canMatch gives flag-off rollback with no deploy.
 *
 * Mirrors dashboardReactGuard exactly (see src/dashboard/guards/dashboard-react-version.guard.ts),
 * on its own `messages-page-enableReact` flag so Messages rolls out independently of the dashboard.
 */
export const messagesReactGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('messages-page-enableReact');
};
